// services/api.js
const API_BASE_URL = 'https://api.laminance.com/api';

// const API_BASE_URL = 'http://localhost:5000/api';



class ApiService {
  constructor() {
    this.baseURL = API_BASE_URL;
  }

  async request(endpoint, options = {}) {
    const url = `${this.baseURL}${endpoint}`;
    
    console.log(`🔄 Making request to: ${url}`);
    
    const config = {
      mode: 'cors',
      credentials: 'include', // 👈 THIS IS CRITICAL for sending cookies
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    };

    if (config.body && typeof config.body === 'object') {
      config.body = JSON.stringify(config.body);
    }

    try {
      const response = await fetch(url, config);
      
      if (response.status === 401) {
        // Token expired or invalid
        throw new Error('Authentication failed. Please login again.');
      }
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      console.log(`✅ Request successful:`, data);
      return data;
    } catch (error) {
      console.error('❌ API Request failed:', error);
      throw new Error(`Network error: ${error.message}`);
    }
  }

   // APPOINTMENT METHODS
  async getAllAppointments() {
    return this.request('/appointments', {
      method: 'GET',
    });
  }

  async getUserAppointments() {
    return this.request('/appointments/user/my-appointments', {
      method: 'GET',
    });
  }

  async getAppointmentById(id) {
    return this.request(`/appointments/${id}`, {
      method: 'GET',
    });
  }

  async getAppointmentsByDate(date) {
    return this.request(`/appointments/date/${date}`, {
      method: 'GET',
    });
  }

  async createAppointment(appointmentData) {
    return this.request('/appointments', {
      method: 'POST',
      body: appointmentData,
    });
  }

  async updateAppointment(id, appointmentData) {
    return this.request(`/appointments/${id}`, {
      method: 'PUT',
      body: appointmentData,
    });
  }

  async deleteAppointment(id) {
    return this.request(`/appointments/${id}`, {
      method: 'DELETE',
    });
  }

  async sendAppointmentEmail(id) {
    return this.request(`/appointments/${id}/send-email`, {
      method: 'POST',
    });
  }


  // CONTACT METHODS
async submitContact(contactData) {
  return this.request('/contact/submit', {
    method: 'POST',
    body: contactData,
  });
}

async getAllContacts(queryParams = {}) {
  const params = new URLSearchParams(queryParams).toString();
  const endpoint = params ? `/contact/admin/all?${params}` : '/contact/admin/all';
  return this.request(endpoint);
}

async getContactStats() {
  return this.request('/contact/admin/stats');
}

async updateContactStatus(id, statusData) {
  return this.request(`/contact/admin/${id}/status`, {
    method: 'PUT',
    body: statusData,
  });
}

  // ORDER METHODS
  async createOrder(orderData) {
    return this.request('/orders/create', {
      method: 'POST',
      body: orderData,
    });
  }

  async getAllOrders() {
    return this.request('/orders/all');
  }

  async getUserOrders() {
    return this.request('/orders/my-orders');
  }

  async getOrders(queryParams = {}) {
    const params = new URLSearchParams(queryParams).toString();
    const endpoint = params ? `/orders/my-orders?${params}` : '/orders/my-orders';
    return this.request(endpoint);
  }

  async getOrderById(orderId) {
    return this.request(`/orders/${orderId}`);
  }

  async updateOrder(orderId, updateData) {
    return this.request(`/orders/${orderId}`, {
      method: 'PUT',
      body: updateData,
    });
  }

  async updateOrderStatus(orderId, status) {
    return this.request(`/orders/${orderId}/status`, {
      method: 'PUT',
      body: { status },
    });
  }

  async deleteOrder(orderId) {
    return this.request(`/orders/${orderId}`, {
      method: 'DELETE',
    });
  }

  // Add authentication check method
  async checkAuth() {
    try {
      const response = await this.request('/user/user-Detail');
      return { isAuthenticated: true, user: response.data };
    } catch (error) {
      return { isAuthenticated: false, user: null };
    }
  }
}

export const apiService = new ApiService();